var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 319.9 319.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.9,0C71.6,0,0,71.6,0,159.9c0,88.3,71.6,159.9,159.9,159.9c88.3,0,159.9-71.6,159.9-159.9C319.9,71.6,248.2,0,159.9,0 L159.9,0z M42.6,159.9c0,2.7-2.2,5-5,5c-2.7,0-5-2.2-5-5c0-61.5,44.9-114.5,105-125.3c1.4-11.1,10.9-19.8,22.4-19.8 c12.5,0,22.7,10.2,22.7,22.7c0,12.5-10.2,22.7-22.7,22.7c-10,0-18.4-6.6-21.4-15.6C83.5,54.9,42.6,103.6,42.6,159.9L42.6,159.9z  M130.5,245.5l7.7-71.7H97.6c-2,0-3.8-1.2-4.6-3c-0.8-1.8-0.4-4,0.9-5.4l97.4-104.5c1.5-1.7,4-2.1,6-1c2,1.1,3.1,3.3,2.5,5.5 l-18.1,79.1h35.5c1.9,0,3.7,1.1,4.5,2.9c0.8,1.8,0.6,3.9-0.7,5.3l-81.7,96.5c-1,1.2-2.4,1.8-3.8,1.8c-0.7,0-1.3-0.2-2-0.4 C131.5,249.7,130.2,247.6,130.5,245.5L130.5,245.5z M179.9,285.6c-1.6,10.9-11,19.4-22.3,19.4c-12.5,0-22.7-10.2-22.7-22.7 c0-12.5,10.2-22.7,22.7-22.7c10.2,0,18.7,6.8,21.6,16c56.3-9.2,98.2-58.1,98.2-115.6c0-2.7,2.2-5,5-5c2.7,0,5,2.2,5,5 C287.3,222.7,241.4,275.9,179.9,285.6L179.9,285.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsIcon);
export default __webpack_public_path__ + "static/media/ups-icon.aa279f7f54416af49f72fa1ee7c38d48.svg";
export { ForwardRef as ReactComponent };